module.exports = __webpack_public_path__ + "media/assets/images/fr-ff21c7a5ba214f86d54f1f2468e36d01.png";